var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPointer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#678DFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50236 5.58791L8.00116 8.59591L7.49996 5.58791C7.48794 5.51518 7.4919 5.4407 7.51155 5.36965C7.5312 5.29859 7.56608 5.23267 7.61377 5.17645C7.66146 5.12023 7.72081 5.07507 7.78771 5.04409C7.85461 5.01312 7.92744 4.99707 8.00116 4.99707C8.07488 4.99707 8.14772 5.01312 8.21462 5.04409C8.28152 5.07507 8.34087 5.12023 8.38856 5.17645C8.43625 5.23267 8.47113 5.29859 8.49078 5.36965C8.51043 5.4407 8.51439 5.51518 8.50236 5.58791Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00107 11.1955C8.22199 11.1955 8.40107 11.0164 8.40107 10.7955C8.40107 10.5746 8.22199 10.3955 8.00107 10.3955C7.78016 10.3955 7.60107 10.5746 7.60107 10.7955C7.60107 11.0164 7.78016 11.1955 8.00107 11.1955Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointer);
export default __webpack_public_path__ + "static/media/pointer.53ac4616fe7efeb60a221db7be38855a.svg";
export { ForwardRef as ReactComponent };